export const EVENT_ACTION = 'view_source';

export const EVENT_LABEL_VIEWER = 'source_viewer';

export const EVENT_LABEL_FALLBACK = 'legacy_fallback';

export const BLAME_AGE_COLORS = {
  'blame-commit-age-0': 'var(--gl-color-data-blue-900)',
  'blame-commit-age-1': 'var(--gl-color-data-blue-800)',
  'blame-commit-age-2': 'var(--gl-color-data-blue-700)',
  'blame-commit-age-3': 'var(--gl-color-data-blue-600)',
  'blame-commit-age-4': 'var(--gl-color-data-blue-500)',
  'blame-commit-age-5': 'var(--gl-color-data-blue-400)',
  'blame-commit-age-6': 'var(--gl-color-data-blue-300)',
  'blame-commit-age-7': 'var(--gl-color-data-blue-200)',
  'blame-commit-age-8': 'var(--gl-color-data-blue-100)',
  'blame-commit-age-9': 'var(--gl-color-data-blue-50)',
};

export const BLAME_COLUMN_DEFAULT_WIDTH = 400;

export const BLAME_COLUMN_MAX_WIDTH = 600;

export const BLAME_COLUMN_MIN_WIDTH = 250;

export const BLAME_COLUMN_WIDTH_STORAGE_KEY = 'blame-column-width';

export const CODEOWNERS_FILE_NAME = 'CODEOWNERS';

export const CODEOWNERS_LANGUAGE = 'codeowners';

export const SVELTE_LANGUAGE = 'svelte';
